export const languageLabels = {
    en: "English",
    ar: "Arabic",
    hi: "Hindi",
    bn: "Bangla",
    kn: "Kannada",
    pa: "Punjabi",
    ta: "Tamil",
    te: "Telugu",
    gu: "Gujarati",
    mr: "Marathi",
    ml: "Malayalam",
    or: "Odia",
    as: "Assamese"
}
